// extracted by mini-css-extract-plugin
module.exports = {"hidden":"infoDetail_hidden__451FC","textEmphasis":"infoDetail_textEmphasis__UTPPX","infoDetailWrap":"infoDetail_infoDetailWrap__XOibR"};